import { useState } from "react";
import { Link } from "react-router-dom";
import { Leaf, CheckCircle2 } from "lucide-react";
import api, { formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { PasswordInput } from "../components/PasswordInput";

export default function RegisterPage() {
  const [form, setForm] = useState({ name: "", email: "", organisation_hint: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/register", form);
      setDone(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F7F7F6] px-6">
      <div className="w-full max-w-sm fade-up">
        <div className="mb-8 flex items-center gap-2.5">
          <div className="flex h-9 w-9 items-center justify-center bg-[#1C4E35]">
            <Leaf size={18} className="text-[#8FD4AC]" />
          </div>
          <span className="font-heading text-base font-black tracking-tight">COP31 PORTAL</span>
        </div>
        {done ? (
          <div className="border border-stone-200 bg-white p-6" data-testid="register-success">
            <CheckCircle2 size={32} className="text-[#1C4E35]" />
            <h1 className="font-heading mt-3 text-xl font-black tracking-tight">Hesabınız Oluşturuldu</h1>
            <p className="mt-2 text-sm text-stone-600">
              Hesabınız <strong>yönetici onayı bekliyor</strong>. Onaylandığında e-posta ile bilgilendirileceksiniz; sonrasında giriş yapabilirsiniz.
            </p>
            <Link to="/login">
              <Button className="mt-5 w-full rounded-sm bg-[#1C4E35] text-white hover:bg-[#143A26]" data-testid="register-back-to-login">
                Giriş Sayfasına Dön
              </Button>
            </Link>
          </div>
        ) : (
          <>
            <p className="text-xs uppercase tracking-[0.2em] text-stone-500">Yeni Hesap</p>
            <h1 className="font-heading mt-2 text-3xl font-black tracking-tight text-[#0A0D0B]">Hesap Oluştur</h1>
            <p className="mt-2 text-sm text-stone-500">Hesabınız yönetici onayından sonra aktif olur.</p>
            <form onSubmit={submit} className="mt-8 space-y-4">
              <div className="space-y-1.5">
                <Label className="text-xs uppercase tracking-wider text-stone-600">Ad Soyad</Label>
                <Input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Ad Soyad" data-testid="register-name-input" className="rounded-sm border-stone-300 bg-white" />
              </div>
              <div className="space-y-1.5">
                <Label className="text-xs uppercase tracking-wider text-stone-600">E-posta</Label>
                <Input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="ornek@firma.com" data-testid="register-email-input" className="rounded-sm border-stone-300 bg-white" />
              </div>
              <div className="space-y-1.5">
                <Label className="text-xs uppercase tracking-wider text-stone-600">Firma Adı (isteğe bağlı)</Label>
                <Input value={form.organisation_hint} onChange={(e) => setForm({ ...form, organisation_hint: e.target.value })} placeholder="Firmanızın adı" data-testid="register-org-input" className="rounded-sm border-stone-300 bg-white" />
              </div>
              <div className="space-y-1.5">
                <Label className="text-xs uppercase tracking-wider text-stone-600">Şifre</Label>
                <PasswordInput value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} testId="register-password-input" />
              </div>
              {error && <p className="border border-red-300 bg-red-50 px-3 py-2 text-xs text-red-700" data-testid="register-error">{error}</p>}
              <Button type="submit" disabled={loading} data-testid="register-submit-button" className="w-full rounded-sm bg-[#1C4E35] text-white hover:bg-[#143A26] active:scale-95">
                {loading ? "Oluşturuluyor..." : "Hesap Oluştur"}
              </Button>
            </form>
            <p className="mt-5 text-sm text-stone-500">
              Zaten hesabınız var mı?{" "}
              <Link to="/login" className="font-medium text-[#1C4E35] hover:underline" data-testid="register-login-link">Giriş yapın</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
